import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';
import './LegalPage.css';

const LegalPage: React.FC = () => {
  const { t } = useTranslation();
  usePageTitle('Legal - Terms & Policies');

  const sections = ['privacy', 'security', 'governance', 'ip'];

  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <span className="section-label">{t('legal.label')}</span>
          <h1>{t('legal.title')}</h1>
          <p className="legal-subtitle">
            {t('legal.subtitle')}
          </p>
        </div>
      </section>

      <section className="legal-content section">
        <div className="container">
          <div className="legal-sections">
            {sections.map((section) => (
              <div key={section} className="legal-section">
                <h2>{t(`legal.sections.${section}.title`)}</h2>
                <p>{t(`legal.sections.${section}.description`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
